import React, { FC } from 'react'
import ImgUtil from '../../../../utils/img.utils'
import DottedModal from '../../dottedModal'
import WrapperImage from '../../wrapperImage'

type Props = {
  mediaTextData: any
  video: any
  handleClose: () => void
  open: boolean
}

const MediaTextModal: FC<Props> = ({ mediaTextData, video, handleClose, open }) => (
  <DottedModal open={open} handleClose={handleClose} type="image">
    {video.animation && video.animationMP4 ? (
      <video src={mediaTextData.asset.url} playsInline autoPlay muted loop />
    ) : (
      <WrapperImage
        src={ImgUtil.getResizedImageUrl(mediaTextData.asset.url, '')}
        //* gifs don't animate with srcset attribute (tested on mac chrome m1)
        {...(!video.animation
          ? {
              srcSet: ImgUtil.getSrcSet(mediaTextData.asset.url),
              sizes: '50vw',
            }
          : {})}
        loading="lazy"
        alt={mediaTextData.asset.altText}
        threshold={650}
      />
    )}
  </DottedModal>
)

export default MediaTextModal
